var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcProtection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5AE5BFB9-44FF-46CE-9F24-11A706A5A987-523-00000CD003C2257C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "portfolio-builder",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.5b-client-profile-moneymind",
    transform: "translate(-164.000000, -315.000000)",
    fill: "#A7D500"
  }, /*#__PURE__*/React.createElement("g", {
    id: "work-area",
    transform: "translate(60.000000, 84.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "content"
  }, /*#__PURE__*/React.createElement("g", {
    id: "client-profile"
  }, /*#__PURE__*/React.createElement("g", {
    id: "clarence",
    transform: "translate(72.000000, 123.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "percentage",
    transform: "translate(0.000000, 73.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "protection"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text",
    transform: "translate(14.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic/hc/protection",
    transform: "translate(18.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0000175,1.70562737e-08 C24.836542,1.70562737e-08 32.0000009,7.16345895 32.0000009,16.0000859 C32.0000009,24.8365761 24.836542,32.0000351 16.0000175,32.0000351 C7.16339058,32.0000351 9.69543601e-09,24.8365761 9.69543601e-09,16.0000859 C9.69543601e-09,7.16345895 7.16339058,1.70562737e-08 16.0000175,1.70562737e-08 Z M16.0000098,6.5454832 C10.7783369,6.5454832 6.54538598,10.7783498 6.54538598,16.0000859 C6.54538598,21.2215479 10.7783369,25.454541 16.0000098,25.454541 C21.2215773,25.454541 25.4545282,21.2215479 25.4545282,16.0000859 C25.4545282,10.7783498 21.2215773,6.5454832 16.0000098,6.5454832 Z M10.5625706,12.0019862 L10.5625706,10.1955838 L12.9074637,9.00938224 L13.0182581,11.6631675 L14.5822018,11.4929128 L14.4140067,9.06618232 L16.8710898,8.72656369 L17.149416,11.2675488 L18.602676,11.0420576 L18.3222909,8.72656369 L21.0037677,9.00938224 L21.0037677,11.0420576 L19.3276202,14.7684625 L21.8954976,22.052563 C21.8954976,22.052563 20.6686902,23.7456379 16.9818841,23.9724382 C13.2987399,24.1979294 11.6793436,23.1259644 11.6793436,23.1259644 L13.0743461,15.5598272 L10.5625706,12.0019862 Z",
    id: "ic_protection"
  })))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcProtection);
export default __webpack_public_path__ + "static/media/ic_protection.bf5c1264dd3c56b9b5c39ae349d49c01.svg";
export { ForwardRef as ReactComponent };